let Test = require('@/mixins/Forms/2019/NRCA_LTI_03_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            functional_test: {
                name: `Functional Testing (NA7.6.1.2.1)`,
                zones: [],
                steps: {
                    step_1: {
                        name: `Step 1: Identify the reference location (the minimum daylighting location in the controlled zone). (NA7.6.1.2.1(a)) For parking garages,
                                illuminance levels should be measured at the farthest edge of the secondary sidelit zone away from the glazing or opening. (Section 130.1(d)3D)`,
                        questions: {
                            question_1: {
                                id: `a`,
                                type: 'Option',
                                question: `Specify the power estimation method to be used: default ratio of power to light (<b>Dfc</b>), cut sheet ratio of power to light
                                            (<b>CSfc</b>) – cut sheet must be attached, measured Amps multiplied by Volts (<b>VA</b>), or measured watts (<b>W</b>).`,
                                options: [
                                    'Dfc',
                                    'CSfc',
                                    'VA',
                                    'W',
                                ],
                                zones: []
                            }
                        }
                    },
                    step_2: {
                        name: `Step 2: No daylight test. Simulate or provide conditions without daylight. (NA7.6.1.2.1(d))`,
                        questions: {
                            question_1: {
                                id: `b`,
                                type: 'Option',
                                question: `Indicate the method used to simulate or provide conditions without daylight: night time manual measurement (<b>Night</b>),
                                            night time illuminance logging (<b>Log</b>), cover fenestration (<b>CF</b>), or cover photosensor (<b>CP</b>)`,
                                options: [
                                    'Night',
                                    'Log',
                                    'CF',
                                    'CP',
                                ],
                                zones: []
                            },
                            question_2: {
                                id: `c`,
                                type: 'Float',
                                question: `Enter the reference illuminance value in footcandles (fc), as measured at the reference location. (NA7.6.1.2.1(d)2) This is the electric lighting illuminance
                                            without any daylight`,
                                zones: []
                            },
                            question_3: {
                                id: `d`,
                                type: 'String',
                                question: `Enter the measured full load power in Volt-Amps (VA) if power estimation method (line a) = VA or in watts (W) if power estimation method = W. <br>
                                            <b>OR</b> Indicate not applicable (<b>N/A</b>) if power estimation method (line a) = Dfc or CSfc`,
                                zones: [],
                            },
                            question_4: {
                                id: `e`,
                                type: 'Boolean',
                                question: `Automatic daylight control system provides appropriate control so that the electric lighting system is providing full light output unless otherwise
                                            specified by design documents. (NA7.6.1.2.1(d)1)`,
                                zones: []
                            },
                            question_5: {
                                id: `f`,
                                type: 'Boolean',
                                question: `Light output is stable with no discernable flicker. (NA7.6.1.2.1(d)3)`,
                                zones: []
                            },
                        }
                    },
                    step_3: {
                        name: `Step 3: Full daylight test. Simulate or provide bright conditions where the daylight illuminance is greater than 150% of the reference
                                illuminance measured in Step 2. (NA7.6.1.2.1(e), Section 130.1(d)3C, Section 130.1(d)3D)`,
                        questions: {
                            question_1: {
                                id: `g`,
                                type: 'Float',
                                question: `Enter the daylight illuminance (light level with the electric lighting turned off) value in footcandles (fc) measured at the reference location`,
                                zones: []
                            },
                            question_2: {
                                id: `h`,
                                type: 'Percentage',
                                question: `Calculate the ratio of daylight illuminance to the reference illuminance in %. ([line g / line c] x 100)`,
                                zones: []
                            },
                            question_3: {
                                id: `i`,
                                type: 'BooleanResult',
                                question: `The ratio of daylight illuminance to the reference illuminance (line h) is greater than 150%. (Section 130.1(d)3C, Section 130.1(d)3D)`,
                                zones: []
                            },
                            question_4: {
                                id: `j`,
                                type: 'Float',
                                question: `Enter the total illuminance (combined daylight and electric light illuminance) in footcandles (fc) measured at the reference location
                                            if power estimation method (line a) = Dfc or CSfc. <b>OR</b> Enter the measured power in Volt-Amps (VA) if power estimation method (line a) = VA, or in watts (W) if power estimation method (line a) = W`,
                                zones: []
                            },
                            question_5: {
                                id: `k`,
                                type: 'StringResult',
                                question: `Calculate the electric lighting illuminance in footcandles (fc) at the reference location if power estimation method (line a) = Dfc or CSfc. (line j – line g) OR
                                            indicate not applicable (N/A) if power estimation method (line a) = VA or W`,
                                zones: [],
                            },
                            question_6: {
                                id: `l`,
                                type: 'Percentage',
                                question: `Calculate the fraction of rated light output in % if power estimation method (line a) = Dfc or CSfc. ([line k / line c] x 100) <b>OR</b>
                                            Indicate not applicable (<b>N/A</b>) if power estimation method (line a) = VA or W`,
                                zones: []
                            },
                            question_7: {
                                id: `m`,
                                type: 'PercentageInput',
                                question: `Enter the dimmed luminaire fraction of rated power in % if power estimation method (line a) = Dfc or CSfc. Click on the button to see the graph.<br>
                                <b>OR</b> Indicate not applicable (<b>N/A</b>) if power estimation method (line a) = VA or W<br>Enter value as decimal (ex .15 for 15%)`,
                                zones: [],
                                image: '/images/continuous-dimming-control-systems.png',
                            },
                            question_8: {
                                id: `n`,
                                type: 'Percentage',
                                question: `Calculate the system power reduction in %.<br>
                                If power estimation method (line a) = Dfc or CSfc, system power reduction = [1 - dimmed luminaire fraction of rated power (line m)]. <b>OR</b><br>
                                If power estimation method (line a) = VA or W, system power reduction = [1 - measured power (line j)/full load power (line d)]`,
                                zones: []
                            },
                            question_9: {
                                id: `o`,
                                type: 'BooleanResult',
                                question: `For areas other than parking garages, the system lighting power reduction of controlled luminaires (line o) is at least 65%.
                                            (NA7.6.1.2.1(e)1, Section 130.1(d)3C) <b>OR</b> For parking garages, the controlled lighting power consumption is zero. (Section 130.1(d)3D)`,
                                zones: []
                            },
                            question_10: {
                                id: `p`,
                                type: 'Boolean',
                                question: `Dimmed lamps are stable with no discernable flicker. (NA7.6.1.2.1(e)1)`,
                                zones: []
                            },
                            question_11: {
                                id: `q`,
                                type: 'Boolean',
                                question: `Only the luminaires in the daylit zones are affected by daylight control. (NA7.6.1.2.1(e)2)`,
                                zones: []
                            },
                            question_12: {
                                id: `r`,
                                type: 'Option',
                                question: `If a PAF is claimed for daylight dimming plus OFF controls, the system automatically turns off the luminaires that are receiving this credit.
                                            (NA7.6.1.2.1(e)3, Section 140.6(a)2H) Enter yes (Y), no (N), or not applicable (N/A).`,
                                options: [
                                    'Yes',
                                    'No',
                                    'N/A',
                                ],
                                zones: []
                            },
                        }
                    },
                    step_4: {
                        name: `Step 4: Partial daylight test. Simulate or provide daylight conditions where illuminance (fc) from daylight only at the reference location is between 60 and 95% of the reference illuminance measured in Step 2. (NA7.6.1.2.1(f))`,
                        questions: {
                            question_0: {
                                id: ``,
                                type: 'Boolean',
                                question: `There  are 0 control steps between ON and OFF?`,
                                zones: []
                            },
                            question_1: {
                                id: `s`,
                                type: 'Option',
                                question: `Indicate method used to simulate or provide conditions with partial daylight: natural daylight manual measurement (<b>ND</b>), light logging (<b>Log</b>), partially cover
                                            fenestration (<b>PCF</b>), open loop setpoint adjustment (<b>OLSA</b>)`,
                                options: [
                                    'ND',
                                    'Log',
                                    'PCF',
                                    'OLSA'
                                ],
                                zones: []
                            },
                            question_2: {
                                id: `t`,
                                type: 'Float',
                                question: `Enter the daylight illuminance (light level without electric light) in footcandles (fc) measured at the reference location`,
                                zones: []
                            },
                            question_3: {
                                id: `u`,
                                type: 'Percentage',
                                question: `Calculate the ratio of daylight illuminance to the reference illuminance in %. ([line t / line c] x 100)`,
                                zones: []
                            },
                            question_4: {
                                id: `v`,
                                type: 'BooleanResult',
                                question: `The ratio of daylight illuminance to the reference illuminance (line u) is between 60 and 95%. (NA7.6.1.2.1(f)) Enter yes (Y) or no (N)`,
                                zones: []
                            },
                            question_5: {
                                id: `w`,
                                type: 'Float',
                                question: `Enter the total illuminance (combined daylight and electric light illuminance) in footcandles (fc) measured at the reference location.`,
                                zones: []
                            },
                            question_6: {
                                id: `x`,
                                type: 'BooleanResult',
                                question: `The total illuminance (line w) is greater than or equal to the reference illuminance (line c). (NA7.6.1.2.1(f)1, Section 130.1(d)3B)`,
                                zones: []
                            },
                            question_7: {
                                id: `y`,
                                type: 'Percentage',
                                question: `Calculate the ratio of total illuminance to the reference illuminance in %. ([line w / line c] x 100)`,
                                zones: []
                            },
                            question_8: {
                                id: `z`,
                                type: 'BooleanResult',
                                question: `The ratio of total illuminance to the reference illuminance (line y) is less than or equal to 150%. (NA7.6.1.2.1(f)2) `,
                                zones: []
                            },
                            question_9: {
                                id: `aa`,
                                type: 'Boolean',
                                question: `The light output is stable with no discernable flicker. (NA7.6.1.2.1(f)3) Enter yes (Y) or no (N).`,
                                zones: []
                            },
                        }
                    },
                },
                comments: '',
                result: false,
            },
        }
    },

    methods: {
        functionalTestEvaluation() {

            if (!this.testIsReady) return;

            this.form.functional_test.result = true;

            if (this.form.functional_test.zones.length == 0) {
                this.form.functional_test.result = false;
            }

            _.each(this.form.functional_test.zones, (zone, index) => {

                var steps = this.form.functional_test.steps;

                // Steps
                var s1Questions = steps.step_1.questions;
                var s2Questions = steps.step_2.questions;
                var s3Questions = steps.step_3.questions;
                var s4Questions = steps.step_4.questions;

                // Line H is N/A when Line A is Dfc or CSfc
                var row_A = s1Questions.question_1.zones[index].answer;

                if (row_A == 'Dfc' || row_A == 'CSfc') {
                    s2Questions.question_3.zones[index].answer = 'N/A';
                } else if (isNaN(s2Questions.question_3.zones[index].answer)) {
                    s2Questions.question_3.zones[index].answer = '';
                }

                // Line E
                if (s2Questions.question_4.zones[index].answer == false) {
                    this.form.functional_test.result = false;
                }

                // Line F
                if (s2Questions.question_5.zones[index].answer == false) {
                    this.form.functional_test.result = false;
                }

                // Line H
                var row_C = s2Questions.question_2.zones[index].answer;
                var row_G = s3Questions.question_1.zones[index].answer;

                if (this.isValidNumber(row_G) && this.isValidNumber(row_C)) {
                    var result = (row_G / row_C);
                    if (this.isValidNumber(result)) {
                        s3Questions.question_2.zones[index].answer = result;
                    } else {
                        s3Questions.question_2.zones[index].answer = '';
                    }
                } else {
                    s3Questions.question_2.zones[index].answer = '';
                }

                // Line I
                s3Questions.question_3.zones[index].answer = (s3Questions.question_2.zones[index].answer > 1.5);
                if (!s3Questions.question_3.zones[index].answer) {
                    this.form.functional_test.result = false;
                }

                // Line K - Line L - Line M - Line N
                var row_J = s3Questions.question_4.zones[index].answer;

                if (row_A == 'Dfc' || row_A == 'CSfc') {

                    // Line K
                    var result = row_J - row_G;
                    s3Questions.question_5.zones[index].answer = result;

                    // Lline K is lower than 0
                    noNegativeAllowed = moment(this.space.created_at).isAfter('2021/01/11');
                    // Change requested by Mario.
                    // https://github.com/NLCAA/acceptance-testing-software/commit/05349b4e128077ca17852a61fce64f34a3724846#diff-4bd731f247b004ee84fc8812aba541ac0c07951837d253d5dc8066f3c39a86d3
                    if(s3Questions.question_5.zones[index].answer < 0 && noNegativeAllowed){
                        s3Questions.question_5.zones[index]['style'] = {
                            color: 'red'
                        }
                        this.form.functional_test.result = false;
                    }else{
                        s3Questions.question_5.zones[index]['style'] = {
                            color: ''
                        }
                    }

                    // Line J
                    var row_K = result;
                    var row_C = s2Questions.question_2.zones[index].answer;
                    result = row_K / row_C;
                    s3Questions.question_6.zones[index].answer = result;

                    // Line M
                    var row_M = s3Questions.question_7.zones[index].answer;
                    if (row_M[0] != '.' && (isNaN(row_M) || row_M < 0 || row_M > 1)) {
                        s3Questions.question_7.zones[index].answer = '';
                    }

                    // Line N
                    if (this.isValidNumber(row_M)) {
                        s3Questions.question_8.zones[index].answer = (1 - row_M);
                    } else {
                        s3Questions.question_8.zones[index].answer = '';
                    }


                } else {
                    s3Questions.question_5.zones[index].answer = 'N/A' // Line K
                    s3Questions.question_6.zones[index].answer = 'N/A'; // Line J
                    s3Questions.question_7.zones[index].answer = 'N/A'; // Line M

                    // Line N
                    var row_D = s2Questions.question_3.zones[index].answer;
                    var row_J = s2Questions.question_4.zones[index].answer;
                    if (this.isValidNumber(row_D) && this.isValidNumber(row_J)) {
                        s3Questions.question_8.zones[index].answer = (1 - (row_J / row_D));
                    } else {
                        s3Questions.question_8.zones[index].answer = '';
                    }
                }

                // Line O
                var row_N = s3Questions.question_8.zones[index].answer;
                s3Questions.question_9.zones[index].answer = (this.isValidNumber(row_N) && (row_N >= .65));
                if (!s3Questions.question_9.zones[index].answer) {
                    this.form.functional_test.result = false;
                }

                // Line P
                if (s3Questions.question_10.zones[index].answer == false) {
                    this.form.functional_test.result = false;
                }

                // Line Q
                if (s3Questions.question_11.zones[index].answer == false) {
                    this.form.functional_test.result = false;
                }

                // Line R
                var row_R = s3Questions.question_12.zones[index].answer;
                if (row_R == 'Yes' && row_N < 1) {
                    this.form.functional_test.result = false;
                }
                if (row_R == '') {
                    this.form.functional_test.result = false;
                }

                // Line S to AA
                if (s4Questions.question_0.zones[index].answer == true) {
                    for (var i = 1; i < 10; i++) {
                        s4Questions['question_' + i].zones[index].display = false
                    }
                    return
                } else {
                    for (var i = 1; i < 10; i++) {
                        s4Questions['question_' + i].zones[index].display = true
                    }
                }

                // Step 4 Starts Here..
                // Line U
                var row_T = s4Questions.question_2.zones[index].answer;
                var row_U = s4Questions.question_3.zones[index].answer = (row_T / row_C);

                // Line V
                var row_V = s4Questions.question_4.zones[index].answer = (this.isValidNumber(row_U) && (row_U >= .60) && (row_U <= .95));
                if (row_V == false) {
                    this.form.functional_test.result = false;
                }

                // Line X
                var row_W = s4Questions.question_5.zones[index].answer;
                var row_X = s4Questions.question_6.zones[index].answer = (row_W >= row_C);
                if (row_X == false) {
                    this.form.functional_test.result = false;
                }

                // Line Y
                var row_Y = s4Questions.question_7.zones[index].answer = (row_W / row_C);

                // Line Z
                var row_Z = s4Questions.question_8.zones[index].answer = (this.isValidNumber(row_Y) && (row_Y >= 1) && (row_Y <= 1.5));
                if (row_Z == false) {
                    this.form.functional_test.result = false;
                }

                // Line AA
                if (s4Questions.question_9.zones[index].answer == false) {
                    this.form.functional_test.result = false;
                }
            })
        }
    },

}
